import { BiTrash } from 'react-icons/bi';

import { PSButton } from '@/components/ui/button';

interface deleteButtonProps {
  deleteHandler: (e?: any) => void;
  onKeyDown?: () => void;
  tabIndex?: number;
}

const DeleteButton = ({ deleteHandler, onKeyDown, tabIndex }: deleteButtonProps) => {
  return (
    <PSButton
      id="btn-delete"
      type="button"
      variant="outlineDanger"
      tabIndex={tabIndex}
      onKeyDown={() => {
        onKeyDown && onKeyDown();
      }}
      onClick={e => {
        deleteHandler();
      }}
    >
      <BiTrash size={24} className="tw-w-6 tw-h-6 tw-relative tw-overflow-hidden" />
    </PSButton>
  );
};

export default DeleteButton;
